import { Radio } from 'antd';
import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import TriggerPointTips from 'views/Marketing/components/TriggerPointTips';
import { DisabledProps, FV, IsPolicyProps, Validate } from './share';

export const validate: Validate = (errors, values, t) => {
  const { praiseTriggerPoint } = values;

  if (!praiseTriggerPoint) {
    // eslint-disable-next-line no-param-reassign
    errors.praiseTriggerPoint = t('marketing.请选择执行节点的订单状态');
  }
};

function PraiseTriggerPointField(props: DisabledProps & IsPolicyProps) {
  const { disabled = false, isPolicy = false } = props;

  const { t } = useTranslate();

  const praiseTriggerLabel = {
    SIGNED: t('marketing.买家签收'),
    CONFIRMED: t('marketing.买家确认收货'),
  };

  return (
    <FormField<FV['praiseTriggerPoint']>
      name={isPolicy ? 'scenarioConfig.praiseTaskConfig.triggerPoint' : 'praiseTriggerPoint'}
      label={
        <div>
          {t('marketing.执行节点')}
          <TriggerPointTips />
        </div>
      }
    >
      {({ field: { value, onChange } }) => {
        return (
          <Radio.Group
            disabled={disabled}
            value={value}
            onChange={({ target: { value } }) => onChange(value)}
          >
            {Object.keys(praiseTriggerLabel).map((value) => {
              return (
                <Radio key={value} value={value}>
                  {praiseTriggerLabel[value]}
                </Radio>
              );
            })}
          </Radio.Group>
        );
      }}
    </FormField>
  );
}

export default PraiseTriggerPointField;
